import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IUser, IUserState } from "../models/User";
import { fetchUserInfo } from "../asyncActions/fetchUserInfo";

const initialState: IUserState = {
  user_info: null,
  auth_key: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAuthKey(state, action: PayloadAction<string | null>) {
      state.auth_key = action.payload;
    },

    setUserInfo(state, action: PayloadAction<IUser | null>) {
      state.user_info = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
      state.user_info = action.payload.data;
    });

    builder.addCase(fetchUserInfo.rejected, (state) => {
      state.user_info = null;
    });
  },
});

export const { setAuthKey, setUserInfo } = userSlice.actions;

export default userSlice.reducer;
